// extracted by mini-css-extract-plugin
export var menuIcon = "MenuIcon-module--menu-icon--7ef73";
export var menuIconLine = "MenuIcon-module--menu-icon-line--26bb6";
export var open = "MenuIcon-module--open--15a20";